import type { RouteRecordRaw } from 'vue-router'

import { routeDealsRoot } from './dealsRoutes'
import { routeQuotationsRoot } from './quotationsRoutes'
import { routeSalesDashboardHome, routeSalesDashboardRoot } from './salesDashboardRoutes'
import { routeSalesOrdersRoot } from './salesOrdersRoutes'

const routeSalesHome: RouteRecordRaw = {
  name: 'sales-home',
  path: '',
  redirect: routeSalesDashboardHome,
}

const routeSalesRoot: RouteRecordRaw = {
  children: [
    routeSalesHome,
    routeDealsRoot,
    routeQuotationsRoot,
    routeSalesOrdersRoot,
    routeSalesDashboardRoot,
  ],
  path: 'sales',
}

export { routeSalesRoot }
